import { render, staticRenderFns } from "./ti4.vue?vue&type=template&id=2b827c32&scoped=true&"
import script from "./ti4.vue?vue&type=script&lang=js&"
export * from "./ti4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b827c32",
  null
  
)

export default component.exports